export default function Centered({ children }: { children: React.ReactNode }) {
	return <div style={{ textAlign: 'center' }}>{children}</div>;
}
